export default {
    announcements: 'ニュースレター',
    announcementsHelper: '月に1、2回ほど新機能などの最新情報を送付します。',
    description: 'ユーザー関連の通知 - {{userEmail}}',
    onboarding: 'ご利用ガイド',
    onboardingHelper:
        'ご利用状況に応じて、MakeLeapsの活用方法などを紹介します。',
    save: '保存',
    systemNotifications: 'システム通知',
    systemNotificationsHelper:
        'パスワードのリセットなどの重要な通知が送信されます。',
    title: '通知設定',
};
